import React, { useState, useEffect } from "react";
import { Calendar, X, Plus, Trash2 } from "lucide-react";
import PhysicalStockEntryTable from "./PhysicalStockEntryTable";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

import useApi from "../../hooks/useApiGetPost";

const PhysicalStockEntry = () => {
   const COMPANY_CODE = localStorage.getItem("companyCode");
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    type: "success",
  });

  const [drAccount, setDrAccount] = useState(null);
  const [crAccount, setCrAccount] = useState(null);

  const DEPARTMENT =
    localStorage.getItem("currentSelectedDepartment") || "MAIN";
  const {
    loading: loadinggetLocationList,
    data: datagetLocationList,
    get: getLocationList,
  } = useApi();

  const {
    loading: loadinggetCategory,
    data: datagetCategory,
    get: getCategory,
  } = useApi();

  const {
    loading: loadinggetSubCategory,
    data: datagetSubCategory,
    get: getSubCategory,
  } = useApi();

  const {
    loading: loadinggetgroup,
    data: datagetgetgroup,
    get: getgroup,
  } = useApi();

  const {
    loading: loadinggetSubgroup,
    data: datagetSubgroup,
    get: getSubgroup,
  } = useApi();

  const {
    loading: loadinggetDebitCredit,
    data: datagetDebitCredit,
    get: getDebitCredit,
  } = useApi();

  const {
    loading: loadinggetVoucherNumber,
    data: datagetVoucherNumber,
    get: getVoucherNumber,
  } = useApi();

  const {
    loading: loadingpostPhysicalStockEntry,
    data: datapostPhysicalStockEntry,
    post: postPhysicalStockEntry,
  } = useApi();

  const [locationList, setLocationList] = useState(null);

  let API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";
  const BASE_URL = API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";

  const [srvNo, setSrvNo] = useState("1001");
  const [date, setDate] = useState("30/12/2025");
  const [takenOnly, setTakenOnly] = useState(true);
  const [adjustStock, setAdjustStock] = useState(true);
  const [lotNo, setLotNo] = useState("");
  const [group, setGroup] = useState("");
  const [sgroup, setSgroup] = useState("");
  const [selectLocation, setSelectLocation] = useState("");
  const [category, setCategory] = useState("");
  const [scategory, setScategory] = useState("");
  const [diffValue, setDiffValue] = useState("");

  const [rows, setRows] = useState([
    {
      id: 1,
      sino: "",
      code: "",
      description: "",
      locn: "",
      unit: "",
      phyQty: "",
      sysQty: "",
      variation: "",
    },
    {
      id: 2,
      sino: "",
      code: "",
      description: "",
      locn: "",
      unit: "",
      phyQty: "",
      sysQty: "",
      variation: "",
    },
    {
      id: 3,
      sino: "",
      code: "",
      description: "",
      locn: "",
      unit: "",
      phyQty: "",
      sysQty: "",
      variation: "",
    },
    {
      id: 4,
      sino: "",
      code: "",
      description: "",
      locn: "",
      unit: "",
      phyQty: "",
      sysQty: "",
      variation: "",
    },
    {
      id: 5,
      sino: "",
      code: "",
      description: "",
      locn: "",
      unit: "",
      phyQty: "",
      sysQty: "",
      variation: "",
    },
  ]);

  const addRow = () => {
    const newRow = {
      id: rows.length + 1,
      sino: "",
      code: "",
      description: "",
      locn: "",
      unit: "",
      phyQty: "",
      sysQty: "",
      variation: "",
    };
    setRows([...rows, newRow]);
  };

  useEffect(() => {
    if (datagetLocationList) {
      setLocationList(datagetLocationList);
    }
  }, [datagetLocationList]);

  const callGetLocationList = () => {
    let apiUrl = `${BASE_URL}/api/CpaysCount/${COMPANY_CODE}/LOCATONLIST_ALL/-/-`;
    getLocationList(apiUrl);
  };

  useEffect(() => {
    callGetLocationList();
    getCategory(
      `${API_PATHS[0].API_CONFIG}/api/mastercount/${COMPANY_CODE}/category/-/-`
    );
    getSubCategory(
      `${API_PATHS[0].API_CONFIG}/api/mastercount/${COMPANY_CODE}/subcategory/-/-`
    );
    getgroup(
      `${API_PATHS[0].API_CONFIG}/api/mastercount/${COMPANY_CODE}/group/-/-`
    );
    getSubgroup(
      `${API_PATHS[0].API_CONFIG}/api/mastercount/${COMPANY_CODE}/subgroup/-/-`
    );
  }, []);

  // Get today's date in YYYY-MM-DD format for max attribute
  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleDateChange = (e) => {
    const dateValue = e.target.value;
    setSelectedDate(dateValue);

    // Format date as DD/MM/YYYY
    if (dateValue) {
      const [year, month, day] = dateValue.split("-");
      setFormattedDate(`${day}/${month}/${year}`);
    } else {
      setFormattedDate("");
    }
  };

  const clearDate = () => {
    setSelectedDate("");
    setFormattedDate("");
  };

  const [selectedDate, setSelectedDate] = useState(getTodayDate);
  const [formattedDate, setFormattedDate] = useState("");

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    if (selectLocation?.trim() === "" || selectLocation === "-") {
      alert("please select location");
      return;
    }

    let modeToPassToApi = takenOnly
      ? "PHYSTKVARIATION_TAKENONLY"
      : "PHYSTKVARIATION";
    let location_to_pass = selectLocation ? selectLocation : "-";

    console.log("group", group);
    let group_to_pass = group ? group : "-";
    let apiUrl = `${BASE_URL}/api/Crmphysicalstockreg/${COMPANY_CODE}/${modeToPassToApi}/${location_to_pass}/${group_to_pass}/-/${selectedDate}`;
    if (!apiUrl.trim()) {
      setError("Please enter an API URL");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await fetch(apiUrl);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      // Handle both array and single object responses
      if (Array.isArray(result)) {
        setData(result);
      } else if (typeof result === "object") {
        setData([result]);
      } else {
        throw new Error("Invalid data format");
      }
    } catch (err) {
      setError(err.message || "Failed to fetch data");
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(()=>{

  //   if(takenOnly === true){
  //       fetchData("PHYSTKVARIATION_TAKENONLY")
  //   }else if (takenOnly === false){
  //       fetchData("PHYSTKVARIATION")
  //   }

  // },[takenOnly])

  useEffect(() => {
    getDebitCredit(
      `${BASE_URL}/api/CRMGLSettings/${COMPANY_CODE}/Scrn_code/PH/-/${DEPARTMENT}/-`
    );

    getVoucherNumber(
      `${BASE_URL}/api/CRMVoucherSettings/${COMPANY_CODE}/VOUCHERNUMBERS/${DEPARTMENT}/GET/PH-Q/-`
    );
  }, []);

  useEffect(() => {
    console.log("datagetDebitCredit datagetVoucherNumber", datagetDebitCredit);

    if (datagetDebitCredit) {
      const credit = datagetDebitCredit.find((acc) =>
        acc.Scrn_code.includes("PH-STK-C")
      );
      const debit = datagetDebitCredit.find((acc) =>
        acc.Scrn_code.includes("PH-STK-D")
      );

      setCrAccount(credit);
      setDrAccount(debit);
    }
  }, [datagetDebitCredit]);

  useEffect(() => {
    if (datapostPhysicalStockEntry) {
      if (datapostPhysicalStockEntry.result?.trim()?.toUpperCase() === "SAVED") {
        setSnack({
          open: true,
          message: `Physical Stock Saved ${datapostPhysicalStockEntry.invoiceNo}`,
          type: "success",
        });
      } else {
        setSnack({
          open: true,
          message: "Failed to save Physical Stock!",
          type: "error",
        });
      }
    }
  }, [datapostPhysicalStockEntry]);

  const handleSave = () => {
    let apiUrl = `${BASE_URL}/api/PhysicalStockRegCRM`;

    let currentUserName_from_local_storage = localStorage.getItem(
      "currentUserName"
    )
      ? localStorage.getItem("currentUserName")
      : "-";
    let arraytopass = [
      {
        cmpcode: COMPANY_CODE,
        modeop: takenOnly ? "PHYSTKVARIATION_TAKENONLY" : "PHYSTKVARIATION",
        phy_no: datagetVoucherNumber[0]?.NEXT_NO,
        phy_date: selectedDate,
        userid: currentUserName_from_local_storage,
        locn: selectLocation ? selectLocation : "-",
        deptno: DEPARTMENT, // department no need to be related to location as sir said
        status: adjustStock ? "1" : "0",
        accountdr: drAccount?.ACCOUNT,
        accdescdr: drAccount?.accdesc,
        accountcr: crAccount?.ACCOUNT,
        accdesccr: crAccount?.accdesc,
      },
    ];

    let serializedData = JSON.stringify(arraytopass);

    postPhysicalStockEntry(apiUrl, serializedData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-cyan-50 to-blue-50 p-4">
      <div className="max-w-7xl mx-auto bg-white rounded-lg shadow-lg overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-cyan-800 to-cyan-900 px-6 py-4 flex justify-between items-center">
          <h1 className="text-2xl font-bold text-white tracking-wide">
            PHYSICAL STOCK ENTRY
          </h1>

          {/* Taken Only */}
          <div className="col-span-2 flex items-center gap-2">
            <label className="text-sm font-semibold text-white whitespace-nowrap">
              Taken Only
            </label>
            <div className="flex items-center gap-2">
              <span className="text-xs font-bold text-white w-6">
                {takenOnly ? "On" : "Off"}
              </span>
              <button
                onClick={() => setTakenOnly(!takenOnly)}
                className={`relative w-11 h-7 rounded-full transition-colors ${
                  takenOnly ? "bg-cyan-600" : "bg-gray-400"
                }`}
              >
                <span
                  className={`absolute top-0.5 left-0.5 w-6 h-6 bg-white rounded-full shadow-md transform transition-transform ${
                    takenOnly ? "translate-x-4" : "translate-x-0"
                  }`}
                />
              </button>
            </div>
          </div>

          {/* Transfer From Stock Counting */}
          <div className="col-span-3">
            <button
              onClick={() => fetchData()}
              className="w-full px-4 py-1.5 bg-cyan-400 text-white font-semibold rounded hover:bg-cyan-500 transition-colors"
            >
              Transfer From Stock Counting
            </button>
          </div>
        </div>

        {/* Control Bar */}
        <div className="bg-gradient-to-r from-cyan-700 to-cyan-800 px-6 py-4">
          <div className="grid grid-cols-12 gap-3 items-center">
            {/* SRV No */}
            <div className="col-span-2 flex items-center gap-2">
              <label className="text-sm font-semibold text-white">SRV No</label>
              {datagetVoucherNumber ? (
                <input
                  type="text"
                  value={datagetVoucherNumber[0]?.NEXT_NO}
                  onChange={(e) => setSrvNo(e.target.value)}
                  className="w-full px-3 py-1.5 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-cyan-300"
                />
              ) : (
                <span>--</span>
              )}
            </div>

            {/* Transfer From Excel */}
            {/* <div className="col-span-2">
              <button className="w-full px-3 py-1.5 bg-white text-cyan-700 font-semibold rounded hover:bg-cyan-50 transition-colors">
                Transfer From Excel
              </button>
            </div> */}

            {/* Print */}
            {/* <div className="col-span-1">
              <button className="w-full px-3 py-1.5 bg-white text-cyan-700 font-semibold rounded hover:bg-cyan-50 transition-colors flex items-center justify-center gap-1">
                PRINT
              </button>
            </div> */}

            {/* Date */}
            <div className="col-span-2 flex items-center gap-2">
              <label className="text-sm font-semibold text-white">DATE</label>
              {/* <div className="relative flex-1">
                <input
                  type="text"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  className="w-full px-3 py-1.5 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-cyan-300"
                />
                <Calendar className="absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              </div> */}

              <input
                type="date"
                value={selectedDate}
                onChange={handleDateChange}
                max={getTodayDate()}
                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent text-gray-700 cursor-pointer"
              />
            </div>

            {/* Adjust Stock */}
            <div className="col-span-2 flex items-center gap-2">
              <label className="text-sm font-semibold text-white whitespace-nowrap">
                Adjust Stock
              </label>
              <div className="flex items-center gap-2">
                <span className="text-xs font-bold text-white w-6">
                  {adjustStock ? "On" : "Off"}
                </span>
                <button
                  onClick={() => setAdjustStock(!adjustStock)}
                  className={`relative w-11 h-7 rounded-full transition-colors ${
                    adjustStock ? "bg-cyan-600" : "bg-gray-400"
                  }`}
                >
                  <span
                    className={`absolute top-0.5 left-0.5 w-6 h-6 bg-white rounded-full shadow-md transform transition-transform ${
                      adjustStock ? "translate-x-4" : "translate-x-0"
                    }`}
                  />
                </button>
              </div>
              {/* <button className="p-1 bg-green-500 hover:bg-green-600 rounded flex-shrink-0">
                <span className="text-white text-sm">✓</span>
              </button>
              <button className="p-1 bg-white hover:bg-gray-100 rounded border border-gray-300 flex-shrink-0">
                <X className="w-4 h-4 text-gray-600" />
              </button> */}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-3 items-center p-2">
          {/* LOT NO */}
          <div className="col-span-2 flex items-center gap-2">
            <label className="text-sm font-semibold text-black whitespace-nowrap">
              LOT NO
            </label>
            <select
              value={lotNo}
              onChange={(e) => setLotNo(e.target.value)}
              className="w-full px-2 py-1.5 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-cyan-300"
            >
              <option value="">Select</option>
            </select>
          </div>

          {/* Select Location */}
          <div className="col-span-2 flex items-center gap-2">
            <label className="text-sm font-semibold text-black whitespace-nowrap">
              LOCATION
            </label>
            <select
              value={selectLocation}
              onChange={(e) => setSelectLocation(e.target.value)}
              className="w-full px-2 py-1.5 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-cyan-300"
            >
              <option value="">Select Location</option>
              {locationList?.map((item) => {
                return <option value={item.loc_code}>{item.DESC}</option>;
              })}
            </select>
          </div>

          {/* GROUP */}
          <div className="col-span-2 flex items-center gap-2">
            <label className="text-sm font-semibold text-black">GROUP</label>
            <select
              value={group}
              onChange={(e) => setGroup(e.target.value)}
              className="w-full px-2 py-1.5 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-cyan-300"
            >
              <option value="">Select Group</option>
              {datagetgetgroup?.map((group) => (
                <option value={group["GRP CODE"]}>{group.DESCRIPTION}</option>
              ))}
            </select>
          </div>

          {/* SGROUP */}
          <div className="col-span-2 flex items-center gap-2">
            <label className="text-sm font-semibold text-black">SGROUP</label>
            <select
              value={sgroup}
              onChange={(e) => setSgroup(e.target.value)}
              className="w-full px-2 py-1.5 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-cyan-300"
            >
              <option value="">Select Sub Group</option>
              {datagetSubgroup?.map((group) => (
                <option value={group["GRP CODE"]}>{group.DESCRIPTION}</option>
              ))}
            </select>
          </div>

          {/* CATEGORY */}
          <div className="col-span-2 flex items-center gap-2">
            <label className="text-sm font-semibold text-black">CATEGORY</label>
            <select
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              className="w-full px-2 py-1.5 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-cyan-300"
            >
              <option value="">Select Category</option>
              {datagetCategory?.map((group) => (
                <option value={group["GRP CODE"]}>{group.DESCRIPTION}</option>
              ))}
            </select>
          </div>

          {/* SCATEGORY */}
          <div className="col-span-2 flex items-center gap-2">
            <label className="text-sm font-semibold text-black">SCATEGOR</label>
            <select
              value={scategory}
              onChange={(e) => setScategory(e.target.value)}
              className="w-full px-2 py-1.5 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-cyan-300"
            >
              <option value="">Select Sub Category</option>
              {datagetSubCategory?.map((group) => (
                <option value={group["GRP CODE"]}>{group.DESCRIPTION}</option>
              ))}
            </select>
          </div>
        </div>

        

        {/* Table */}
        <div className="overflow-x-auto">
          {data && (
            <PhysicalStockEntryTable
              data={data}
              loading={loading}
              error={error}
            />
          )}
        </div>

        {/* Footer */}
        <div className="bg-gradient-to-r from-cyan-800 to-cyan-900 px-6 py-4">
          <div className="flex justify-between items-center">
            {/* Left side - Account info */}
            <div className="flex gap-4">
              <div className="bg-white px-4 py-2 rounded shadow-sm flex items-center gap-2">
                <span className="text-sm font-semibold text-gray-600">Dr</span>
                <span className="font-bold text-red-700">
                  {drAccount?.ACCOUNT || "N/A"}
                </span>
                <span className="text-sm text-gray-600">
                  {drAccount?.accdesc || "No Description"}
                </span>
              </div>
              <div className="bg-white px-4 py-2 rounded shadow-sm flex items-center gap-2">
                <span className="text-sm font-semibold text-gray-600">Cr</span>
                <span className="font-bold text-green-700">
                  {crAccount?.ACCOUNT || "N/A"}
                </span>
                <span className="text-sm text-gray-600">
                  {crAccount?.accdesc || "No Description"}
                </span>
              </div>
            </div>

            {/* Center - Diff Value */}
            {/* <div className="flex items-center gap-2">
              <label className="text-sm font-semibold text-white">
                Diff Value
              </label>
              <input
                type="text"
                value={diffValue}
                onChange={(e) => setDiffValue(e.target.value)}
                className="px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-cyan-300"
              />
            </div> */}

            {/* Right side - Buttons */}
            <div className="grid grid-cols-2 gap-2">
              {/* <button className="px-6 py-2 bg-white text-cyan-700 font-semibold rounded hover:bg-cyan-50 transition-colors">
                ADD ROW
              </button> */}
              <button
                onClick={() => handleSave()}
                className="px-6 py-2 bg-white text-cyan-700 font-semibold rounded hover:bg-cyan-50 transition-colors"
              >
                SAVE
              </button>
              {/* <button className="px-6 py-2 bg-white text-cyan-700 font-semibold rounded hover:bg-cyan-50 transition-colors">
                SAVE&PRINT
              </button>
              <button className="px-6 py-2 bg-white text-cyan-700 font-semibold rounded hover:bg-cyan-50 transition-colors">
                VIEW
              </button> */}
            </div>
          </div>
        </div>
      </div>

      <Snackbar
        open={snack.open}
        autoHideDuration={3000}
        onClose={() => setSnack({ ...snack, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={() => setSnack({ ...snack, open: false })}
          severity={snack.type}
          variant="filled"
          elevation={6}
        >
          {snack.message}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

export default PhysicalStockEntry;
